import { Link } from "react-router-dom";
import { XCircle, ArrowUpRight } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-background text-foreground flex flex-col">
            <Nav />
            <section className="flex-1 grain">
                <div className="mx-auto max-w-[1600px] px-6 md:px-10 pt-32 pb-24 grid grid-cols-12 gap-6 items-end">
                    <div className="col-span-12 md:col-span-8">
                        <div className="flex items-center gap-3 mb-8 text-[11px] tracking-[0.24em] uppercase text-muted-foreground">
                            <XCircle size={14} className="text-destructive" />
                            <span>Payment cancelled</span>
                        </div>
                        <h1 className="font-editorial tracking-tighter text-[12vw] md:text-[8.4vw] lg:text-[7.2vw] leading-[0.86]">
                            No worries.
                            <br />
                            <span className="italic text-accent">Try again</span> when you&rsquo;re ready.
                        </h1>
                        <p className="mt-10 max-w-lg text-base text-muted-foreground leading-relaxed">
                            No charge was made. Have questions before enrolling? Call a specialist
                            directly — we&rsquo;ll walk you through what to expect.
                        </p>
                        <div className="mt-10 flex flex-wrap gap-3">
                            <Link
                                to="/enroll"
                                className="group inline-flex items-center gap-3 bg-foreground text-background px-6 py-4 text-[13px] tracking-[0.16em] uppercase hover:bg-accent"
                                data-testid="cancel-try-again"
                            >
                                Try again
                                <ArrowUpRight size={16} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                            </Link>
                            <a
                                href="tel:5127831895"
                                className="inline-flex items-center gap-3 border border-foreground px-6 py-4 text-[13px] tracking-[0.16em] uppercase hover:bg-foreground hover:text-background"
                            >
                                Talk to a specialist
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}
